// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__MK0b0","nav":"Navbar_nav__y-wOX"};